export const POLICY = {
  // Válido mientras generation coincida
  EVENT: "event",

  // Válido por un tiempo determinado
  TTL: "ttl",

  // Válido 1 sola vez (nunca más se vuelve a sincronizar)
  ONCE: "once",
};